<template>
  <div class="gb1" id="gb1">
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: "noData",
  methods: {},
  data() {
    return {};
  },
};
</script>

<style>
.gb1 {
  text-align: center;
  display: flex;
  justify-content: center;
  line-height: 200px;
  width: 1200px;
  height: 200px;
  min-height: 200px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
}
</style>



// WEBPACK FOOTER //
// src/components/component/noData.vue